module.exports = __webpack_public_path__ + "static/media/docusign.7d1bb256.png";